import gql from "graphql-tag";

export const termsOfServiceMutation = gql`
  mutation CreateCurrentUserTermsOfService(
    $input: CreateCurrentUserTermsOfServiceInput!
  ) {
    createCurrentUserTermsOfService(input: $input) {
      id
    }
  }
`;

export const acceptedTermsOfServiceQuery = gql`
  query AcceptedTermsOfServiceCheck($input: FindAllUserTermsOfServiceInput!) {
    acceptedCurrentTermsOfService(input: $input) {
      id
    }
  }
`;
